

import Vue from "vue";
import { BusinessInfo, OnboardingSupplements, RouteInvitationLink, ValidatedSteps } from "@/types/data";
import { Dictionary, update } from "lodash";
import axios from "axios";
import _ from 'lodash'
import { ActionTypes, MutationTypes } from "@/enums/vuex";
const brregUrl = "https://data.brreg.no/enhetsregisteret/api/enheter/"
export default Vue.extend({
    name: "PersonalInformationForm",
    data(): {
            loading: boolean
            nameRules: any
            firstNameInput: string
            lastNameInput: string
    } {
        return {
            loading: false,
            nameRules: [
            (v:any) => /^(.){2,30}$/.test(v) || 'Navn må være mellom 2 og 30 bokstaver.', // [a-zæøåA-ZÆØÅäöÄÖ\- ]
            ],
            firstNameInput: "",
            lastNameInput: "",
        }
    },
    watch: {

    },
    computed: {
        isFormValid(): boolean {
            let form: any
            form = this?.$refs?.personalInfoForm
            return form.validate() ?? false
        },
    },
    methods: {
        async updatePersonalInfo(){

            if(this.isFormValid){
                let supplements: OnboardingSupplements = await this.$store.getters.getContext.onboardingSupplements
                supplements.firstName = this.firstNameInput
                supplements.lastName = this.lastNameInput
                this.$store.dispatch(ActionTypes.setOnboardingSupplementInfo, supplements)
            }
            this.updateFormValidity()
        },
        async updateFormValidity() {
            
            const validatedSteps: ValidatedSteps = await this.$store.getters.getContext.validatedSteps
            validatedSteps.personalInfoForm = this.isFormValid

            this.$store.dispatch(ActionTypes.setValidatedSteps, validatedSteps)
            
        }
    }
});
